import { NotificationsList } from "@circle-react-shared/Notifications/List";
import type { Tab as NotificationTabKey } from "@circle-react-shared/Notifications/NotificationContext";
import type { NotificationTab } from "@circle-react-shared/Notifications/types";
import { Tab } from "@circle-react-uikit/TabV2";
import { CounterBadge } from "@circle-react/components/shared/CounterBadge";

interface NotificationTabsLegacyProps {
  activeTab: NotificationTabKey;
  onTabChange: (tab: NotificationTabKey) => void;
  tabs: NotificationTab[];
  tabsContainerRef: (node: HTMLDivElement | null) => void;
  tabsContainerWidth: number;
}

export const NotificationTabsLegacy = ({
  activeTab,
  onTabChange,
  tabs,
  tabsContainerRef,
  tabsContainerWidth,
}: NotificationTabsLegacyProps) => {
  const selectedIndex = tabs.findIndex(tab => tab.value === activeTab);

  return (
    <Tab.Group className="w-fit overflow-hidden" selectedIndex={selectedIndex}>
      <div className="w-fit px-6" ref={tabsContainerRef}>
        <Tab.List listClassName="gap-4 sm:gap-6">
          {tabs.map(tab => (
            <Tab
              key={tab.value}
              className="text-sm"
              onClick={() => {
                onTabChange(tab.value);
              }}
            >
              <div className="flex items-center gap-1">
                {tab.label}
                {tab.badge && <CounterBadge count={tab.badge} />}
              </div>
            </Tab>
          ))}
        </Tab.List>
      </div>
      <div className="border-primary w-full border-b" />
      <NotificationsList style={{ width: tabsContainerWidth }} />
    </Tab.Group>
  );
};
